import { TipoDocumento } from '../tipo/tipo-documento.class';

export class IdentificacionProspecto {
    numero: String;
    tipo: TipoDocumento;
    fechaExpedicion: Number;
    
    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/models/prospecto/identificacion-prospecto.class.ts